const apiFetcher = (apiClient, ...args) => {
  return apiClient.apiRequest(args[0]);
};

export default apiFetcher;
